import Vue from "vue";
import Vuex from "vuex";
import * as jsonpatch from 'fast-json-patch';
import {
  SECTION,
  GRID,
  CELL,
  WIDGET,
  SYSTEM_WIDGET,
  SLIDE_ITEM,
  SLIDE_BLOCK,
  SECTION_PAGE_PRODUCT,
  SECTION_PAGE_PRODUCT_ITEM,
  SECTION_PAGE_CONTENT,
  SECTION_PAGE_CONTENT_ITEM,
  SECTION_PAGE_CONTACT,
  SECTION_PAGE_FORM_ITEM,
  SECTION_PAGE_ALBUM,
  SECTION_PAGE_PRODUCT_BRAND,
  SECTION_PAGE_FAQ,
  SECTION_PAGE_ALBUM_ITEM,
  SECTION_PAGE_EVENT_CALENDAR,
  SECTION_PAGE_EVENT_CALENDAR_ITEM,
  SECTION_PAGE_QUOTATION_FORM_ITEM,
  SECTION_PAGE_GIFTCARD,
  SLIDE_SECTION,
  SLIDE_PAGE,
  SLIDE_CONTAINER
} from "@model/components/componentMeta.model";

// For Parent
import design from "@store/modules/design";
import designIframe_ghost from "@store/modules/designIframe_ghost";

// For Child
import designIframe from "@store/modules/designIframe";
import design_ghost from "@store/modules/design_ghost";

Vue.use(Vuex);

// const getLocalStorge = () => {
//   let snapshotSynce = localStorage.getItem('snapshotData') || [];
//   if(snapshotSynce.length) {
//     snapshotSynce = JSON.parse(snapshotSynce);
//   }
//   return snapshotSynce;
// }

const store = new Vuex.Store({
  state: {
    mounted: false,
    menuIsFull: true,
    screenSize: '',
    screenWidth: 0,
    screenHeight: 0,
    scrollPosition: 0,
    module: undefined,
    registerMouseDownEvent: [],
    renderMode : 'editor',
  },
  modules: {},
  getters: {
    screenSize: (state) => {
      return state.screenSize;
    },
    module: (state) => {
      return state.module;
    },
    mounted: (state) => {
      return state.mounted;
    },
    detectDevice: (state) => {
      if (state.module == 'design') {
        return state.screenSize.toLocaleLowerCase();

      } else if (state.module == 'designIframe') {
        // const width = Math.round(state.screenWidth)
        // if (width >= 992) {
        //   return 'desktop'
        // } else if (width >= 768) {
        //   return 'tablet'
        // } else {
        //   return 'mobile'
        // }
        return state.screenSize.toLocaleLowerCase();
      }
      return undefined;
    },
    screenWidth: (state) => {
      return state.screenWidth;
    },
    screenHeight: (state) => {
      return state.screenHeight;
    },
    scrollPosition: (state) => {
      return state.scrollPosition;
    },
    renderMode: (state) => {
      return state.renderMode;
    },
  },
  mutations: {
    SET_SCREEN_SIZE(state, size) {
      state.screenSize = size;
    },
    SET_MOUNTED(state, module) {
      state.mounted = !!module
    },
    SET_MODULE(state, module) {
      state.module = module;
    },
    MOUSEDOWN_EVENT(state, { module, event }) {
      state.registerMouseDownEvent.map(fn => fn(event, module));
    },
    ADD_MOUSEDOWN_EVENT(state, fn) {
      state.registerMouseDownEvent.push(fn)
    },
    REMOVE_MOUSEDOWN_EVENT(state, fn) {
      if (state.registerMouseDownEvent.includes(fn)) {
        state.registerMouseDownEvent.splice(state.registerMouseDownEvent.indexOf(fn), 1);
      }
    },
    UPDATE_SCREEN_DIMENSION(state) {
      // state.screenSize = size;
      if (typeof (window.innerWidth) == 'number') {
        state.screenWidth = window.innerWidth;
        state.screenHeight = window.innerHeight;
      } else {
        if (document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)) {
          state.screenWidth = document.documentElement.clientWidth;
          state.screenHeight = document.documentElement.clientHeight;
        } else {
          if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
            state.screenWidth = document.body.clientWidth;
            state.screenHeight = document.body.clientHeight;
          }
        }
      }
    },
    UPDATE_SCROLL_POSITION(state) {
      state.scrollPosition = window.scrollY
    },
  },
  actions: {
    setModule({ commit }, { module }) {
      commit('SET_MOUNTED', module);
      commit("SET_MODULE", module);
      
      if (module == 'design') { // Parent
        if (!this.hasModule("design")) this.registerModule("design", design);
        if (!this.hasModule("designIframe")) this.registerModule("designIframe", designIframe_ghost);

      } else if (module == 'designIframe') { // Child
        if (!this.hasModule("design")) this.registerModule("design", design_ghost);
        if (!this.hasModule("designIframe")) this.registerModule("designIframe", designIframe);
      }
    },
    initialiseStore({ state, commit, dispatch, rootState }) {
      dispatch("setScreenSize", { size: localStorage.getItem('screenSize') || 'Desktop', setLocalStorage: false });
      if(state.module == 'design') {
        window.addEventListener('beforeunload', (e) => {
          let snapshot = jsonpatch.compare(rootState.design.original.metadataObserverOriginal.object , rootState.design.snapshot.metadataObserver.object);
          if(snapshot.length) {
            if(state.design && state.design.snapshot && state.design.snapshot.patchError) return;
            if(state.design && state.design.snapshot && state.design.snapshot.syncError) return;
    
            dispatch('design/snapshot/synceSnapshot', {});
            // Cancel the event
            e.preventDefault();
            // Chrome requires returnValue to be set
            e.returnValue = '';
          }
        });
        window.addEventListener('online', () => {
          console.log('Became online');
          // dispatch('design/snapshot/mergelogs', {isPatch : false});
          dispatch('design/snapshot/synceSnapshot', {});
        });
      }
      window.addEventListener("resize", () => commit("UPDATE_SCREEN_DIMENSION"));
      window.addEventListener("scroll", () => commit("UPDATE_SCROLL_POSITION"));
      window.addEventListener('mouseup', (event) => {
        dispatch('designIframe/windowEvent/mouseupEvent', { event: JSON.parse(JSON.stringify(event)) })
      });
      window.addEventListener('keypress', (event) => {
        if (state.module == 'designIframe') { 
          dispatch('designIframe/windowEvent/keypressEvent', { event: event })
        }
      });
      window.addEventListener("mousedown", (event) => {
        dispatch("mousedownEvent", { module: state.module, event })

        if (state.module == 'design') {
          
          dispatch("design/postToChildren", {
            func: "mousedownEvent",
            root: true,
            payload: { module: state.module, event: JSON.parse(JSON.stringify({event})) },
          })

          /// Check Components Active
          const compIndex = state.design.component.elActiveID.indexOf('component')
          if (compIndex >= 0) {

            let activeComponent = "";
            if (state.design.component.elActiveID.length <= 2) {
              activeComponent = state.design.metadata.screen.pages.assets.components[state.design.component.elActiveID[compIndex + 1]];
            } else {
              if (state.design.component.elActiveID[1].search(WIDGET.prefixKey) == 0) { // widget ex: ['component', 'wdgXXX', 'setting']
                activeComponent = state.design.metadata.screen.pages.assets.components[state.design.component.elActiveID[compIndex + 1]];
              } else {
                activeComponent = state.design.metadata.screen.pages.assets.components[state.design.component.elActiveID[state.design.component.elActiveID.length - 1]];
              }
            }

            if (!activeComponent) return;

            const typeList = [
              SECTION,
              GRID,
              CELL,
              WIDGET,
              SYSTEM_WIDGET,
              SLIDE_ITEM,
              SLIDE_BLOCK,
              SECTION_PAGE_PRODUCT,
              SECTION_PAGE_PRODUCT_ITEM,
              SECTION_PAGE_CONTENT,
              SECTION_PAGE_CONTENT_ITEM,
              SECTION_PAGE_CONTACT,
              SECTION_PAGE_FORM_ITEM,
              SECTION_PAGE_ALBUM,
              SECTION_PAGE_PRODUCT_BRAND,
              SECTION_PAGE_FAQ,
              SECTION_PAGE_ALBUM,
              SECTION_PAGE_ALBUM_ITEM,
              SECTION_PAGE_EVENT_CALENDAR,
              SECTION_PAGE_EVENT_CALENDAR_ITEM,
              SECTION_PAGE_QUOTATION_FORM_ITEM,
              SECTION_PAGE_GIFTCARD,
              SLIDE_SECTION,
              SLIDE_PAGE,
              SLIDE_CONTAINER,
            ];

            // const activeComponentType = typeList.filter(type => activeComponent.id.search(type.prefixKey) == 0)[0]
            const activeComponentType = typeList.find(type => {
              if (type.prefixKey) {
                return activeComponent.id.search(type.prefixKey) == 0;
              } else {
                return activeComponent.type == type.type;
              }
            });

            switch (activeComponentType.name) {
              case "section":
                break;
              case "section_page_content":
                break;
              case "grid":
                break;
              case "cell": {
                  dispatch("designIframe/frame/setCellActive", {
                    component_id: state.design.component.elActiveParentID[state.design.component.elActiveParentID.length - 1],
                    parent_id: state.design.component.elActiveParentID[state.design.component.elActiveParentID.length - 3]
                  })
                  break;
                }
              case "widget":
                if (state.design.component.elActiveParentID[1].includes("slp")) { // Slide Container
                  const section_id = state.design.component.elActiveParentID[0];
                  const slide_page_id = state.design.component.elActiveParentID[1];
                  const indexSlidePage = state.design.metadata.screen.pages.assets.components[section_id].componentsID.indexOf(slide_page_id)
                  dispatch("designIframe/frame/setSlideWidgetActive", {
                    component_id: activeComponent.id,
                    slide_section_id: section_id,
                    index: indexSlidePage,
                  });
                } else {
                  if(state.design.component.elActiveParentID.length === 6){// widget text in interactive
                    dispatch("designIframe/frame/setWidgetActive", {
                      grid_id: state.design.component.elActiveParentID[state.design.component.elActiveParentID.length - 5],
                      cell_id: state.design.component.elActiveParentID[state.design.component.elActiveParentID.length - 4],
                      component_id: activeComponent.id,
                    });
                  }else{
                    dispatch("designIframe/frame/setWidgetActive", {
                      grid_id: state.design.component.elActiveParentID[state.design.component.elActiveParentID.length - 4],
                      cell_id: state.design.component.elActiveParentID[state.design.component.elActiveParentID.length - 3],
                      component_id: activeComponent.id,
                    });
                  }
                }
                break;
              case "systemWidget":
                dispatch("designIframe/frame/setWidgetActive", {
                  grid_id: state.design.component.elActiveParentID[state.design.component.elActiveParentID.length - 4],
                  cell_id: state.design.component.elActiveParentID[state.design.component.elActiveParentID.length - 3],
                  component_id: activeComponent.id,
                });
                break;
              case "slideItem":
                break;
              case "slideBlock":
                dispatch("designIframe/frame/setSlideBlockActive", {
                  component_id: state.design.component.elActiveID[state.design.component.elActiveID.length - 1],
                  parent_id: state.design.component.elActiveID[state.design.component.elActiveID.length - 2],
                  index: activeComponent.properties.index
                })
                break;
              case "slidePage": {
                  const indexSlidePage = state.design.metadata.screen.pages.assets.components[state.design.component.elActiveID[1]].componentsID.indexOf(activeComponent.id)
                  dispatch("designIframe/frame/setSlideSectionActive", {
                    component_id: state.design.component.elActiveID[1],
                    index: indexSlidePage
                  }) 
                  break;
                }
              case "slideContainer":
                dispatch("designIframe/frame/setSlideContainerActive", {
                  component_id: state.design.component.elActiveID[state.design.component.elActiveID.length - 1],
                })
                break;
              default:
            }
          }
          // dispatch("designIframe/frame/setWidgetActive", {
          //   component_id: activeComponent.id,
          // });
          // dispatch("designIframe/frame/reRenderFrame")
        } else {
          dispatch("designIframe/postToParent", {
            func: "mousedownEvent",
            root: true,
            payload: { module: state.module, event: JSON.parse(JSON.stringify(event)) },
          })
        }
        // dispatch("designIframe/frame/setCellHover", {
        //   component_id: undefined,
        // });
      });
    },
    destroyStore({ commit, dispatch }) {
      window.removeEventListener("resize", () => commit("UPDATE_SCREEN_DIMENSION"));
      window.removeEventListener("scroll", () => commit("UPDATE_SCROLL_POSITION"));
      window.removeEventListener("mousedown", () => dispatch("mousedownEvent"));
    },
    mousedownEvent({ commit }, { module, event }) {
      commit("MOUSEDOWN_EVENT", { module, event })
    },
    
    setScreenSize({ commit }, { size, setLocalStorage = true }) {
      if (setLocalStorage) localStorage.setItem('screenSize', size);
      commit("SET_SCREEN_SIZE", size);
    },
  },
});

export default store;
